import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderLock = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M23 16H15V21H23V16Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 16V14C21 12.8954 20.1046 12 19 12C17.8954 12 17 12.8954 17 14V16", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V11C22.4844 10.3136 21.7964 9.76397 21 9.41602V7H12.5859L9.58594 4H3V19H12V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderLock.js.map